/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore", "jquery"], function (_, $) {
  var loadPlugins = function() {

    var resourceUrl = Mindbreeze.require.toUrl("api/download").replace(/\?.*/, ""),
        baseUrl = Mindbreeze.require.toUrl("").replace(/\?.*/, ""),
        resourcePath = resourceUrl.replace(baseUrl, "");
        
    var globalDeferred = $.Deferred();

    function initPlugins(pluginConfig) {
      var deferreds = _.map(pluginConfig, function (config) {
        var pluginsLoadedDeferred = $.Deferred();
        var initRequirements = [];
        var paths = {};
        paths[config.id] = resourcePath + "/" + config.id;
        initRequirements.push(config.id + "/" + config.init);
        var req =Mindbreeze.require.config({ paths: paths });
        
        req(initRequirements, function () {
          pluginsLoadedDeferred.resolve();
        }, function (errors) {
          pluginsLoadedDeferred.resolve();
        });
        return pluginsLoadedDeferred;
      });

      $.when.apply($, deferreds ).then(
        // done
        function() {
          globalDeferred.resolve();
        },
        // error
        function() {
          globalDeferred.resovle();
        }
       );
    }

    Mindbreeze.require(["plugin-config"], initPlugins);

    return globalDeferred.promise();
  }

  
  return { loadPlugins: loadPlugins };
});
